export default "__VITE_ASSET__BHQJ7omt__"